import React from 'react';
import {Link, useLocation} from 'react-router-dom'
import Stylesheet from './NotFound.module.css';
import Button from '../../elements/Button/Button'
import { ico_poo } from '../../icon';

function PageNotFound() {
    // get request details
    const location = useLocation();
    const request = location.state;

    return (
        <div className={Stylesheet.Container}>
            <div className={Stylesheet.Content}>
                <h1 className={Stylesheet.icon}>{ico_poo}</h1>
                <h1>404</h1>
                <h2>{
                    request?.from !== undefined
                    ? request.from +' \''+request.id+'\' ' : "content"
                } not found</h2>
                <Button type='secondary-black'>
                    {<Link to='/'>Go to Home Page</Link>}</Button>
            </div>
        </div>  
    )
}

export default PageNotFound;